export default {
  patrocinados: [],
  tipoComida: [],
  distritos: [],
  colecciones: [],
  currentCountry: {},
  locals: [],
  houndreds: [],
  recommendations: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/locals/state.js